export { EloCoinsIcon } from './coins-icon'
